import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getIn } from 'formik'

import CarouselInstagramStoriesPreview from '../../../../../../../features/components/FacebookPreviews/CarouselInstagramStoriesPreview'
import Button from '../../../../../../../components/Button'
import StoriesForm from './StoriesForm'

import useLineItemDetails from '../../hooks/useLineItemDetails'

import { STORIES_ITEM_SELECTED_INDEX, STORIES_ITEMS } from '../../../../fields'
import { FILE_URL } from '../../../../../../ReusableFormFields/AdFileUpload/fields'

import useStepFormStyles from '../../../../../../../styles/common/stepForms'

const StoriesStep = ({ formik, handleStepChange, isStepFieldsValid, isActive }) => {
  const [showError, setShowError] = useState(false)
  const { t } = useTranslation()

  const stepFormClasses = useStepFormStyles()

  const { values, setFieldValue } = formik

  const selectedItemIndex = values[STORIES_ITEM_SELECTED_INDEX]
  const fileUrl = getIn(values, `${STORIES_ITEMS}[${selectedItemIndex}].${FILE_URL}`)

  const { isCarouselAdAllowed, isVideoViews } = useLineItemDetails()

  const stepTitle = useMemo(() => {
    if (isCarouselAdAllowed) {
      // Multiple stories
      if (isVideoViews) {
        return 'Select videos'
      } else {
        return 'Select images or videos'
      }
    } else {
      // Single story
      if (isVideoViews) {
        return 'Select a video'
      } else {
        return 'Select an image or video'
      }
    }
  }, [isCarouselAdAllowed, isVideoViews])

  const handleLeftSideClick = useCallback(() => {
    setFieldValue(STORIES_ITEM_SELECTED_INDEX, selectedItemIndex - 1)
  }, [setFieldValue, selectedItemIndex])

  const handleRightSideClick = useCallback(() => {
    setFieldValue(STORIES_ITEM_SELECTED_INDEX, selectedItemIndex + 1)
  }, [setFieldValue, selectedItemIndex])

  const handleContinue = useCallback(() => {
    handleStepChange([STORIES_ITEMS])
    setShowError(true)
  }, [handleStepChange])

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t(stepTitle)}</div>
      <div className={stepFormClasses.stepBody}>
        <CarouselInstagramStoriesPreview
          formikValues={values}
          elementInProgress={STORIES_ITEMS}
          fileUrl={fileUrl}
          handleLeftSideClick={handleLeftSideClick}
          handleRightSideClick={handleRightSideClick}
        />
        <StoriesForm
          formik={formik}
          showError={showError}
          setShowError={setShowError}
          isStepFieldsValid={isStepFieldsValid}
        />
      </div>

      <div className={stepFormClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default StoriesStep
